import React from "react";
import "./index.css";
import SurveyMakerForm from "./SurveyMakerForm";

class EditSurveyModal extends React.Component {
  surveyForm = null;
  state = {
    publishBtnDisable: true,
    survey: null,
  };

  render() {
    const { survey, hex, white, brandName } = this.props;

    return (
      <div
        className="modal fade"
        id="edit_survey_form_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit: {survey && survey.name}</h5>
              <div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div className="modal-body">
              <div className="survey-maker-content">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: -10,
                  }}
                >
                  {survey && (
                    <SurveyMakerForm
                      ref={(ref) => (this.surveyForm = ref)}
                      initial={survey}
                      publishSurvey={this.props.updateSurvey}
                      onUpdateStatus={(survey) => {
                        this.setState({
                          survey,
                          publishBtnDisable:
                            !survey.name ||
                            !survey.welcomeText ||
                            survey.communicationLayers.some(
                              (obj) => !obj.type || !obj.statement
                            ),
                        });
                      }}
                      hex={hex}
                      white={white}
                      brandName={brandName}
                    />
                  )}
                  {this.state.survey &&
                    this.state.survey.name &&
                    this.state.survey.welcomeText && (
                      <div className="survey-publish-options">
                        <button
                          className="btn btn-white btn-brand-hex"
                          style={{
                            "--hover-text-color": white ? "white" : "black",
                            "--hover-color": hex,
                            backgroundColor: "white",
                            color: "black",
                          }}
                          type="button"
                          onClick={() =>
                            this.surveyForm
                              ? this.surveyForm.addNewCommunicationLayer()
                              : null
                          }
                        >
                          Add new communication layer
                        </button>
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div
              className="modal-footer"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <button
                type="button"
                className="btn delete-button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.props.deleteSurvey}
              >
                <span>Delete</span>
              </button>
              <div className="modal-footer__container">
                <button
                  type="button"
                  className="btn btn-white btn-brand-hex"
                  style={{
                    "--hover-text-color": white ? "white" : "black",
                    "--hover-color": hex,
                    backgroundColor: "white",
                    color: "black",
                  }}
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-green"
                  data-dismiss="modal"
                  onClick={() =>
                    this.surveyForm
                      ? this.surveyForm.handlePublishSurvey()
                      : null
                  }
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default EditSurveyModal;



// WEBPACK FOOTER //
// ./src/screens/SurveyMaker/EditSurveyModal.js